/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Agent_Authorization_ExpiryInputs */

const en_agent_authorization_expiry = /** @type {(inputs: Agent_Authorization_ExpiryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This authorization request expires at ${i?.time}.`)
};

const zh_agent_authorization_expiry = /** @type {(inputs: Agent_Authorization_ExpiryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此授权请求将在 ${i?.time} 过期。`)
};

/**
* | output |
* | --- |
* | "This authorization request expires at {time}." |
*
* @param {Agent_Authorization_ExpiryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_expiry = /** @type {((inputs: Agent_Authorization_ExpiryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_ExpiryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_expiry(inputs)
	return zh_agent_authorization_expiry(inputs)
});
export { agent_authorization_expiry as "agent.authorization.expiry" }